/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reducer, useReducer } from "react";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const toggleReducer = (state: boolean, nextValue?: any) => (typeof nextValue === "boolean" ? nextValue : !state);

export const useToggle = (initialValue: boolean): [boolean, (nextValue?: any) => void] =>
  useReducer<Reducer<boolean, any>>(toggleReducer, initialValue);
